// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "day-34ho_ day-1Symv";
var _3 = "dayOfWeekName-2R3M0";
var _4 = "dayOfWeekName_withPrices-34Aw-";
var _5 = "week-3vEer";
export { _1 as "__esModule", _2 as "day", _3 as "dayOfWeekName", _4 as "dayOfWeekName_withPrices", _5 as "week" }
export default { "__esModule": _1, "day": _2, "dayOfWeekName": _3, "dayOfWeekName_withPrices": _4, "week": _5 }
